const CLUB727_SELECTOR = '[data-club-727-enrollment]';
const TZ = 'America/Los_Angeles';
const ACK_VERSION = 'v5.2';
const FOUR = (n) => String(n).padStart(4, '0');
const TWO = (n) => String(n).padStart(2, '0');

function partsForLosAngeles(date = new Date()) {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = Object.fromEntries(formatter.formatToParts(date).map(({ type, value }) => [type, value]));
  const year = Number(parts.year);
  const month = Number(parts.month);
  const day = Number(parts.day);
  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day) || month < 1 || month > 12 || day < 1 || day > 31) {
    throw new Error('Unable to resolve Club 727 enrollment date.');
  }
  return { year, month, day };
}

function plusMonths(year, month, amount) {
  const index = year * 12 + (month - 1) + amount;
  return { year: Math.floor(index / 12), month: (index % 12) + 1 };
}

function isoMonth({ year, month }) { return `${FOUR(year)}-${TWO(month)}`; }
function isoDate({ year, month }, day) { return `${FOUR(year)}-${TWO(month)}-${TWO(day)}`; }
function displayDate({ year, month }, day) {
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(Date.UTC(year, month - 1, day, 12)));
}
function displayMonth({ year, month }) {
  return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(Date.UTC(year, month - 1, 1, 12)));
}

function assignment(now = new Date()) {
  const local = partsForLosAngeles(now);
  const current = { year: local.year, month: local.month };
  const deferred = local.day >= 11;
  const benefit = deferred ? plusMonths(local.year, local.month, 1) : current;
  const nextCharge = deferred ? plusMonths(benefit.year, benefit.month, 1) : plusMonths(current.year, current.month, 1);
  return {
    state: deferred ? 'deferred_next_month' : 'current_month',
    benefitMonth: isoMonth(benefit),
    benefitMonthLabel: displayMonth(benefit),
    benefitStartDate: deferred ? isoDate(benefit, 1) : `${FOUR(local.year)}-${TWO(local.month)}-${TWO(local.day)}`,
    benefitStartLabel: deferred ? displayDate(benefit, 1) : 'immediately',
    pickupStartDate: isoDate(benefit, 15),
    pickupStartLabel: displayDate(benefit, 15),
    nextChargeDate: isoDate(nextCharge, 1),
    nextChargeLabel: displayDate(nextCharge, 1),
  };
}

function setField(root, key, value) {
  const input = root.querySelector(`[data-club727-field="${key}"]`);
  if (input) input.value = value;
}

function setPurchaseEnabled(root, enabled) {
  const productAvailable = root.dataset.club727ProductAvailable === 'true';
  const allowPurchase = enabled && productAvailable;
  root.querySelectorAll('button[type="submit"][name="add"]').forEach((button) => {
    button.disabled = !allowPurchase;
  });
  root.querySelectorAll('.accelerated-checkout-block').forEach((node) => {
    node.hidden = !allowPurchase;
    node.toggleAttribute('aria-hidden', !allowPurchase);
  });
}

function initialize(root) {
  if (root.dataset.club727Ready === 'true') return;
  root.dataset.club727Ready = 'true';
  const disclosure = root.querySelector('[data-club727-disclosure]');
  const checkbox = root.querySelector('[data-club727-consent]');
  const error = root.querySelector('[data-club727-error]');
  const form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
  if (!disclosure || !checkbox || !form) return;

  setPurchaseEnabled(root, false);
  checkbox.checked = false;

  let resolved;
  try {
    resolved = assignment();
    if (resolved.state === 'current_month') {
      disclosure.innerHTML = `<strong>You’re joining for ${resolved.benefitMonthLabel}.</strong> Your $34.99 membership payment, plus applicable tax, will be collected today. Your Club 727 benefits begin immediately. Your first plant package will be available for pickup beginning ${resolved.pickupStartLabel} after you receive your pickup-ready email. Your next automatic payment is scheduled for ${resolved.nextChargeLabel} unless canceled before the scheduled charge.`;
    } else {
      disclosure.innerHTML = `<strong>You’re joining for ${resolved.benefitMonthLabel}.</strong> Your $34.99 membership payment, plus applicable tax, will be collected today and applied to ${resolved.benefitMonthLabel}. Your benefits begin ${resolved.benefitStartLabel}, and your first plant package will be available for pickup beginning ${resolved.pickupStartLabel} after you receive your pickup-ready email. You will not be charged again on the upcoming 1st. Unless canceled, your next automatic payment is scheduled for ${resolved.nextChargeLabel}.`;
    }
    setField(root, 'state', resolved.state);
    setField(root, 'benefit_month', resolved.benefitMonth);
    setField(root, 'benefit_start_date', resolved.benefitStartDate);
    setField(root, 'pickup_start_date', resolved.pickupStartDate);
    setField(root, 'next_charge_date', resolved.nextChargeDate);
    setField(root, 'ack_version', ACK_VERSION);
    if (error) error.hidden = true;
  } catch (e) {
    disclosure.textContent = 'Club 727 enrollment is temporarily unavailable because we could not resolve your membership dates. Please contact Grounded Gardens for assistance.';
    if (error) error.hidden = false;
    checkbox.disabled = true;
    return;
  }

  const sync = () => {
    const accepted = checkbox.checked;
    setPurchaseEnabled(root, accepted);
    setField(root, 'acknowledged_at', accepted ? new Date().toISOString() : '');
    root.classList.toggle('club727-consent-complete', accepted);
  };
  checkbox.addEventListener('change', sync);
  form.addEventListener('submit', (event) => {
    if (!checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkbox.focus();
      if (error) { error.hidden = false; error.textContent = 'Please acknowledge the recurring membership terms before continuing.'; }
    }
  }, true);
  sync();
}

function boot() { document.querySelectorAll(CLUB727_SELECTOR).forEach(initialize); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
document.addEventListener('shopify:section:load', boot);
